<p-dialog
    [visible]="formIoShareDialogService.visible()"
    appendTo="body"
    [modal]="true"
    [style]="{'max-width': '700px', width: '100%'}"
    styleClass="center-header m-dialog-header-text"
    [header]="header">
    <ng-template pTemplate="content">
        <div class="p-g pt-3">
            <div class="p-g-12">
                <form [formGroup]="formIoShareDialogService.shareFileForm" (ngSubmit)="formIoShareDialogService.share()">
                    <div class="inputs-group">
                        <div class="inputs-group-row">
                            <div class="inputs-group-row-name">User Types:</div>
                            <div class="inputs-group-row-value">
                                <p-multiSelect
                                    [options]="formIoShareDialogService.userTypeOptions"
                                    appendTo="body"
                                    (onChange)="formIoShareDialogService.filterUsers($event)"
                                    placeholder="All User Types"
                                    formControlName="userTypes">
                                </p-multiSelect>
                            </div>
                        </div>
                        <div class="inputs-group-row">
                            <div class="inputs-group-row-name">Users:</div>
                            <div class="inputs-group-row-value">
                                <p-multiSelect
                                    [options]="formIoShareDialogService.userSuggestions"
                                    (onFilter)="formIoShareDialogService.filterUsers($event)"
                                    (onChange)="formIoShareDialogService.onUserChange($event)"
                                    appendTo="body"
                                    placeholder="Select users..."
                                    formControlName="users"
                                    optionLabel="fullName">
                                </p-multiSelect>
                            </div>
                        </div>
                        <div class="inputs-group-row">
                            <div class="inputs-group-row-name asterisk-mark">Emails:</div>
                            <div class="inputs-group-row-value">
                                <p-chips
                                    formControlName="emails"
                                    class="p-fluid dialog-p-chips"
                                    [addOnBlur]="true"
                                    [addOnTab]="true"
                                    (onAdd)="formIoShareDialogService.addEmail($event.value)"
                                    (onRemove)="formIoShareDialogService.removeEmail($event.value)"
                                    [allowDuplicate]="false">
                                </p-chips>
                            </div>
                        </div>
                    </div>
                    <div class="inputs-group-row">
                        <form-buttons
                            [disabled]="formIoShareDialogService.shareFileForm.invalid"
                            [saving]="formIoShareDialogService.sharingFile"
                            [config]="shareFileFormButtonsConfig">
                        </form-buttons>
                    </div>
                </form>
            </div>
        </div>
    </ng-template>
</p-dialog>